import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'page-content, [page-content], [pageContent], mir-page-content, [mir-page-content], [mirPageContent]',
    standalone: false
})
export class PageContentDirective {

  @HostBinding('class') hostCssClasses = 'mir-page-content page-content';

}
